import { trim, join } from 'lodash';
export const UpperCaseFirstLetter = (word: string) => {
  if (!word) return '';
  return word?.charAt(0).toUpperCase() + word?.substring(1).toLowerCase();
};
export const UpperFirstLetterSentence = (sentence: string) =>
  join(
    sentence?.split(' ')?.map(w => UpperCaseFirstLetter(trim(w))),
    ' ',
  );

export const FormatPercentage = (val: number, digits = 2): number => Number(val.toFixed(digits));

export const StripCpf = (cpf: string): string => cpf?.split('.').join('').split('-').join('');
export const IsValidCpf = (cpf: string): boolean => {
  cpf = StripCpf(cpf);
  if (!cpf || cpf == '00000000000') return false;
  let Soma = 0;
  let Resto;
  let i;
  for (i = 1; i <= 9; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;
  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(cpf.substring(9, 10))) return false;
  Soma = 0;
  for (i = 1; i <= 10; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;
  if (Resto == 10 || Resto == 11) Resto = 0;
  return Resto == parseInt(cpf.substring(10, 11));
};

export const ReplaceAtWord = (txt: string) => {
  const splitted = txt.split(' ');
  return splitted
    .map((word: string) =>
      word.substring(0, 1) == '@' ? `<span style="color:var(--primary-color)">${word}</span>` : word,
    )
    .join(' ');
};
